// apps/client/src/game/bus.ts — the game's event bus (§8.7). GameBusEvents is augmentable like GameCommands.
// Producers (all M0-T18): 'press:tool' ← cmd.press('tool'); 'space:changed' ← game/spaces.ts after a scene switch
// (the first scene of a visit, or a different space; a resync of the same space does not emit it);
// 'hour:changed' / 'day:changed' ← the Game's ClockTicker (once a second, never on the first tick after a snapshot).
import type { DayKey, HourKey, SpaceId } from '@whiskerton/shared';

export interface GameBusEvents { 'press:tool': undefined; 'space:changed': { from: SpaceId; to: SpaceId }; 'day:changed': { dayKey: DayKey }; 'hour:changed': { hourKey: HourKey } }

export class Bus<E> {
  private readonly subs = new Map<keyof E, Set<(p: never) => void>>();
  on<K extends keyof E>(name: K, fn: (payload: E[K]) => void): () => void {
    let s = this.subs.get(name);
    if (!s) this.subs.set(name, (s = new Set()));
    s.add(fn as (p: never) => void);
    return () => { s.delete(fn as (p: never) => void); };
  }
  emit<K extends keyof E>(name: K, payload: E[K]): void {
    for (const fn of [...(this.subs.get(name) ?? [])]) (fn as (p: E[K]) => void)(payload);
  }
}
